
var envir = {
  production: true,
  company: "Thành Bưởi",
  title: "Thành Bưởi",
  name: "Thành Bưởi",

  tokenFirebase: "AIzaSyAY9k6gMHd_wx-IiLyhzzYdKh_xhpOxKeM",
  urlFirebase: "https://fcm.googleapis.com/fcm/send",
  hub: {
    centerHubLongName: "Trung tâm",
    centerHubSortName: "TT",
    poHubLongName: "Chi nhánh",
    poHubSortName: "CN",
    stationHubLongName: "Bưu cục",
    stationHubSortName: "BC",
  },
  namePrint: "Thành Bưởi",
  gMapKey: "AIzaSyCkR-wl8rYwyb5XhvinbcfZOuFsRV2IFDo",
  urlLogo: "assets/images/logo/thanhbuoi.png",
  urlLogoMini: "assets/images/logo/thanhbuoi_mini.png",
  // apiGeneralUrl: "http://core-tms-devapi.dsc.vn/api",
  // apiCRMUrl: "http://cusinfo-tms-devapi.dsc.vn/api",
  // apiPostUrl: "http://op-tms-devapi.dsc.vn/api",

  /* ------- PROD ------- */
  // apiGeneralUrl: "https://coreapi.thanhbuoi.vn/api",
  // apiCRMUrl: "https://crmapi.thanhbuoi.vn/api",
  // apiPostUrl: "https://postapi.thanhbuoi.vn/api",
  // apiFileCRMUrl: "https://crmapi.thanhbuoi.vn/",

  // ------STG----
  apiGeneralUrl: "http://core-api-tbe.ssw.vn/api",
  apiCRMUrl: "http://crm-api-tbe.ssw.vn/api",
  apiPostUrl: "http://post-api-tbe.ssw.vn/api",
  apiFileCRMUrl: "http://crm-api-tbe.ssw.vn/",

  formatDate: "YYYY/MM/DD",
  formatDateTable: "yyyy/MM/dd",
  formatDateTime: "YYYY/MM/DD HH:mm",
  formatDateTimeTable: "yyyy/MM/dd HH:mm",
  firebase: {
    apiKey: "AIzaSyBwjHPz6q5c0lNukX_9q_UXD3SiviB8cOU",
    authDomain: "dsc-demo-cb5fb.firebaseapp.com",
    databaseURL: "https://dsc-demo-cb5fb.firebaseio.com",
    projectId: "dsc-demo-cb5fb",
    storageBucket: "dsc-demo-cb5fb.appspot.com",
    messagingSenderId: "631002885321"
  }
}
export const environment = envir;


// WEBPACK FOOTER //
// C:/Users/LIVE02/Documents/SSW/ThanhBuoi/TBE_CRM/src/environments/environment.ts